// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1hvWm","title":"InfoRow_title__1kex5"};